import { gql } from 'graphql-request';

const query = gql`
  query contentTypes {
    contentTypes {
      contentType
      name
      slug
    }
  }
`;

export default query;
